import { PlaybookRisk } from 'src/services';
import { TrafficSplit } from './TrafficStep/types';

export type TrafficPresetId = 'cautious' | 'standard' | 'all_in';

export interface TrafficPreset {
  id: TrafficPresetId;
  label: string;
  description: string;
  split: TrafficSplit;
}

export const TRAFFIC_PRESETS: TrafficPreset[] = [
  {
    id: 'cautious',
    label: 'Cautious',
    description: 'Most of your traffic stays on production while the test proves itself.',
    split: { production: 80, control: 10, variant: 10 },
  },
  {
    id: 'standard',
    label: 'Standard',
    description: 'A balanced split for most tests.',
    split: { production: 10, control: 45, variant: 45 },
  },
  {
    id: 'all_in',
    label: 'All-in',
    description: 'No production arm — every shopper is in the test.',
    split: { production: 0, control: 50, variant: 50 },
  },
];

export const RISK_TO_PRESET_ID: Record<PlaybookRisk, TrafficPresetId> = {
  high: 'cautious',
  medium: 'standard',
  low: 'all_in',
};

const getSplitForPresetId = (presetId: TrafficPresetId): TrafficSplit => {
  const preset = TRAFFIC_PRESETS.find(p => p.id === presetId);
  if (!preset) throw new Error(`Unknown traffic preset id: ${presetId}`);
  return preset.split;
};

export const RECOMMENDED_SPLIT: Record<PlaybookRisk, TrafficSplit> = {
  high: getSplitForPresetId(RISK_TO_PRESET_ID.high),
  medium: getSplitForPresetId(RISK_TO_PRESET_ID.medium),
  low: getSplitForPresetId(RISK_TO_PRESET_ID.low),
};

export const BUILD_YOUR_OWN_RISK: PlaybookRisk = 'medium';
